import { render } from "./CIS-Resource-PagedListing-Badge.vue?vue&type=template&id=4f09224e&scoped=true"
import script from "./CIS-Resource-PagedListing-Badge.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-PagedListing-Badge.vue?vue&type=script&lang=js"

import "./CIS-Resource-PagedListing-Badge.vue?vue&type=style&index=0&id=4f09224e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f09224e"]])

export default __exports__